import { Adslot } from '../modules/adslot-controller/adslot.js';
import { EffectFunction } from './index.js';

export const SHOW_AD_LABEL: EffectFunction = ({ advertLabel, options }: Adslot) => {
    advertLabel.classList.remove('sdgCloaked', 'sdgRemoved');

    return () => {
        if (options.reserveSpace) {
            advertLabel.classList.add('sdgCloaked');
        } else {
            advertLabel.classList.add('sdgRemoved');
        }
    };
};
